import { NavigationItem, UserData } from 'common/models/navigation';
import React from 'react';
import { Logo } from '../Logo/Logo';
import { UserProfile } from 'components/organisms/User-Profile/UserProfile';
import { Navigation } from '../NavigationMenu/navigation-menu';

interface SidebarProps {
	collapsed: boolean;
	onToggle: () => void;
	activeItem?: string;
	onNavigate?: (item: NavigationItem) => void;
	user: UserData;
	permittedPages?: string[];
	/** NEW: disable fixed positioning when rendered in a mobile drawer */
	insideDrawer?: boolean;
	onSettings?: () => void;

}

export const Sidebar: React.FC<SidebarProps> = ({
	collapsed,
	onToggle,
	permittedPages,
	user,
	insideDrawer = false,
	onSettings,
}) => {
	const positionClasses = insideDrawer
		? 'relative' // inside drawer -> follow drawer container
		: 'fixed top-0 left-0 z-[60] md:relative md:z-auto'; // desktop/original

	const widthClasses = insideDrawer
		? 'w-full' // drawer defines the width
		: collapsed
		? 'w-[var(--sidebar-collapsed)] min-w-[var(--sidebar-collapsed)] max-w-[var(--sidebar-collapsed)]'
		: 'w-[var(--sidebar-open)] min-w-[var(--sidebar-open)] max-w-[var(--sidebar-open)]';

	return (
		<div
      className={`bg-white z-[60] flex flex-col h-full overflow-hidden transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)] border-r-0 md:border-r border-tertiary-background ${positionClasses} ${widthClasses}`}

		>
			<Logo collapsed={collapsed} onToggleSidebar={onToggle} />

			<Navigation collapsed={collapsed} permittedPages={permittedPages} />

			<div className={`flex items-center  ${collapsed ? 'justify-center' : 'justify-start py-[14px] pl-[18px] pr-3'}`}>
				<UserProfile user={user} collapsed={collapsed} onSettings={onSettings} />
			</div>
		</div>
	);
};
